import { cn, Header, HeaderTitle } from "@jana-technology/platform-ui";

import type { MainHeaderProps } from "./types";

export const MainHeader = ({ title, topText, children }: MainHeaderProps) => {
  return (
    <Header>
      <div className="flex flex-wrap justify-between gap-4">
        <div>
          <div className={cn({ "mb-2": topText })}>
            <span className="text-sm font-medium">{topText}</span>
          </div>

          <HeaderTitle>{title}</HeaderTitle>
        </div>
        <div className="flex items-center gap-3">{children}</div>
      </div>
    </Header>
  );
};

export default MainHeader;
